import { AsyncAction } from "@/Common/Api/AsyncActions/AsyncAction";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { MedicalItemVitalSign } from "@/Patient/Models/MedicalSummary/MedicalItemVitalSign";

export class VitalSignActions extends AsyncAction {
    private static actions = new VitalSignActions();

    public static async save(
        vitalSign: MedicalItemVitalSign,
        reasonForVisit: string,
        patientContactId: string,
        patientContactFacetId: string,
        consultationTypeId: string,
        activeSiteId: string
    ): Promise<any> {
        return await this.actions.postAsync<any>(
            ServerOperations.Server.Myle_Patient_SaveVitalSign,
            {
                VitalSign: vitalSign,
                ReasonForVisit: reasonForVisit,
                PatientContactId: patientContactId,
                PatientContactFacetId: patientContactFacetId,
                ConsultationTypeId: consultationTypeId,
                ActiveSiteId: activeSiteId
            }
        );
    }

    public static async invalidateOrDelete(serverOperationNumber: number, medicalItemId: string): Promise<void> {
        return await this.actions.postAsync<null>(
            serverOperationNumber,
            {
                MedicalItemId: medicalItemId
            }
        );
    }
}
